export default __webpack_public_path__ + "static/media/image53.73ae4567.png";